import { render } from "./blockArr.vue?vue&type=template&id=7a4f8e94&scoped=true"
import script from "./blockArr.vue?vue&type=script&lang=js"
export * from "./blockArr.vue?vue&type=script&lang=js"

import "./blockArr.vue?vue&type=style&index=0&id=7a4f8e94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4f8e94"]])

export default __exports__